// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1so7j","itemTitle":"ClientEmergencyInfo_itemTitle__3XU_r","itemText":"ClientEmergencyInfo_itemText__1VhJG"};